import { StyleSheet, View } from 'react-native';
import { colors } from '../../theme/colors';
import { tokens } from '../../theme/tokens';
import { fieldFontFamily } from '../../theme/typography';

interface TimePickerInputProps {
  value: string;
  onChange: (time: string) => void;
  accessibilityLabel: string;
  testID?: string;
}

export function TimePickerInput({
  value,
  onChange,
  accessibilityLabel,
  testID,
}: TimePickerInputProps) {
  return (
    <View style={styles.container}>
      <input
        data-testid={testID}
        aria-label={accessibilityLabel}
        type="time"
        step={300}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        style={{
          border: 'none',
          background: 'transparent',
          color: colors.text.primary,
          fontSize: tokens.fontSize.basePlus,
          fontFamily: fieldFontFamily,
          fontVariantNumeric: 'tabular-nums',
          outline: 'none',
          width: '100%',
          height: 42,
          padding: 0,
          margin: 0,
          cursor: 'pointer',
          colorScheme: 'dark',
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    minWidth: 116,
    height: 44,
    justifyContent: 'center',
    borderRadius: tokens.radius.md,
    borderWidth: 1,
    borderColor: colors.border.input,
    backgroundColor: colors.background.input,
    paddingHorizontal: tokens.spacing.smPlus,
  },
});
